import { useState, useEffect } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative h-screen">
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/8e563ca5-c856-4df8-ac33-ff016d92cfb7.png" 
              alt="日本音楽会場協会 東京クラブ" 
              className="h-12 w-auto"
            />
            <div className={`transition-colors duration-300 ${scrolled ? 'text-gray-900' : 'text-white'}`}>
              <div className="text-sm font-medium">日本音楽会場協会</div>
              <div className="text-xs">東京クラブ</div>
            </div>
          </div>
          <div className="flex items-center gap-8">
            <a href="#activities" className={`text-sm font-medium transition-colors duration-300 hover:opacity-70 cursor-pointer whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}>活動紹介</a>
            <a href="#venues" className={`text-sm font-medium transition-colors duration-300 hover:opacity-70 cursor-pointer whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}>参加会場</a>
            <a href="#artists" className={`text-sm font-medium transition-colors duration-300 hover:opacity-70 cursor-pointer whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}>登録アーティスト</a>
            <a href="#schedule" className={`text-sm font-medium transition-colors duration-300 hover:opacity-70 cursor-pointer whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}>ライブスケジュール</a>
            <a href="#contact" className={`text-sm font-medium transition-colors duration-300 hover:opacity-70 cursor-pointer whitespace-nowrap ${scrolled ? 'text-gray-700' : 'text-white'}`}>お問い合わせ</a>
          </div>
        </div>
      </nav>

      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/b800958e90e6a87f80c81229a963967e.jpg" 
          alt="ライブハウス" 
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="text-center text-white px-6 w-full">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-wide">東京の音楽シーンを支える</h1>
          <p className="text-xl md:text-2xl mb-8 font-light">地域のライブハウス活動を通じて、音楽文化の発展に貢献します</p>
          <a href="#activities" className="inline-block bg-white text-gray-900 px-8 py-3 rounded-md text-sm font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap">
            活動内容を見る
          </a>
        </div>
      </div>
    </div>
  );
}